<template>
  <UserAttributesInteractiveForm :busy="busy" @submit="submit" />
</template>
<script>
import { mapActions } from 'vuex'
import UserAttributesInteractiveForm from '@/components/forms/user/interactive/UserAttributesInteractiveForm.vue'
export default {
  name: 'UserAttributesInteractiveFormContainer',
  components: {
    UserAttributesInteractiveForm,
  },
  emits: ['userAttributesSubmitted'],
  data() {
    return {
      busy: true,
    }
  },
  async mounted() {
    await this.actGetUserAttributes()
    this.busy = false
  },
  methods: {
    ...mapActions({
      actGetUserAttributes: 'user/user-attributes/actGetUserAttributes',
      actSetUserAttributes: 'user/user-attributes/actSetUserAttributes',
    }),
    async submit(userAttributes) {
      this.busy = true
      await this.actSetUserAttributes({ userAttributes })
      this.busy = false
      this.$emit('userAttributesSubmitted', userAttributes)
    },
  },
}
</script>
<style lang="scss"></style>
